import { exhaustiveFail } from '@cbridge-utils/error';
import { IApiTriggeredAlert, ApiAlertType, IApiRecipient, IApiSubscription } from '@cbridge-packages/api-notifications';
import { ITriggeredAlert, AlertType, IAlertRecipient, IAlertSubscription } from './alert.interface';

export namespace AlertTranslator {
  export function fromApi(alert: IApiTriggeredAlert): ITriggeredAlert {
    return {
      id: alert.id,
      emailSkipped: alert.emailSkipped,
      emailTitle: alert.emailTitle,
      eventType: alert.eventType,
      guide: alert.guide,
      message: alert.message,
      recipients: alert.recipients?.map(AlertTranslator.fromApiRecipient),
      severity: alert.severity,
      time: alert.time,
      type: AlertTranslator.fromApiAlertType(alert.type),
    };
  }

  export function fromApiSubscription(subscription: IApiSubscription): IAlertSubscription {
    return {
      type: AlertTranslator.fromApiAlertType(subscription.type),
      enabled: subscription.enabled,
      recipients: subscription.recipients,
      cooldownSec: subscription.cooldownSec,
    };
  }

  export function fromApiRecipient(user: IApiRecipient): IAlertRecipient {
    return {
      email: user.email,
      error: user.error,
      isSent: user.sent,
    };
  }

  export function fromApiAlertType(type: ApiAlertType): AlertType {
    switch (type) {
      case ApiAlertType.Connectivity:
        return AlertType.Connectivity;
      case ApiAlertType.Ops:
        return AlertType.Ops;
      case ApiAlertType.OpsClient:
        return AlertType.OpsClient;
      case ApiAlertType.Pricing:
        return AlertType.Pricing;
      case ApiAlertType.Risk:
        return AlertType.Risk;
      case ApiAlertType.Trading:
        return AlertType.Trading;
      default:
        return exhaustiveFail(type);
    }
  }

  export function toApiAlertType(type: AlertType): ApiAlertType {
    if (!type) {
      return undefined;
    }

    switch (type) {
      case AlertType.Connectivity:
        return ApiAlertType.Connectivity;
      case AlertType.Ops:
        return ApiAlertType.Ops;
      case AlertType.OpsClient:
        return ApiAlertType.OpsClient;
      case AlertType.Pricing:
        return ApiAlertType.Pricing;
      case AlertType.Risk:
        return ApiAlertType.Risk;
      case AlertType.Trading:
        return ApiAlertType.Trading;
      default:
        return exhaustiveFail(type);
    }
  }
}
